import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddressModalComponent } from './address-modal.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [AddressModalComponent],
  imports: [CommonModule, FormsModule, MatIconModule, ReactiveFormsModule],
  exports: [AddressModalComponent],
})
export class AddressModalModule {}
